import * as React from 'react';
import ReactSelect, { ValueType, ActionMeta } from 'react-select';
import { MenuPlacement } from 'react-select/src/types';
import { SelectOption } from './types';

// The default theme overrides the CSS classes
import { customStylesMulti } from './customStylesMulti';

interface SelectProps {
    name: string;
    options: Array<SelectOption>;
    value: ValueType<SelectOption, true>;
    placeholder?: string;
    onChange: (value: ValueType<SelectOption, true>, actionMeta: ActionMeta<SelectOption>) => void;
    isDisabled?: boolean;
    isClearable?: boolean;
    isCreatable?: boolean;
    ariaLabel?: string;
    className?: string;
    menuPlacement?: MenuPlacement;
}

export const MultiSelect: React.FC<SelectProps> = ({
    name,
    options,
    value,
    placeholder = 'Select...',
    onChange,
    ariaLabel = 'select component',
    className,
    isDisabled = false,
    isClearable = false,
    menuPlacement = 'bottom',
    ...otherProps
}) => {
    return (
        <ReactSelect
            isMulti
            options={options}
            isDisabled={isDisabled}
            isClearable={isClearable}
            closeMenuOnSelect
            aria-label={ariaLabel}
            onChange={onChange}
            placeholder={placeholder}
            value={value}
            styles={customStylesMulti()}
            className={className}
            menuPlacement={menuPlacement}
            {...otherProps}
        />
    );
};
